import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoRecebidoService from '../../servicos/DetalhesRecursoRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConvenentesConcedentesRecebidoInicio: [],
    buscaConvenentesConcedentesRecebidoSucesso: ['convenentesConcedentesRecebido'],
    buscaConvenentesConcedentesRecebidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaConvenentesConcedentesRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConvenentesConcedentesRecebidoInicio())
        let serv = new DetalhesRecursoRecebidoService()
        return serv
            .consultarConvenentesConcedentes(filtro)
            .then(response => dispatch(Creators.buscaConvenentesConcedentesRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConvenentesConcedentesRecebidoErro(error)))
    }
}

const buscaConvenentesConcedentesRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConvenentesConcedentesRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConvenentesConcedentesRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.convenentesConcedentesRecebido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONVENENTES_CONCEDENTES_RECEBIDO_INICIO]: buscaConvenentesConcedentesRecebidoInicio,
    [Types.BUSCA_CONVENENTES_CONCEDENTES_RECEBIDO_ERRO]: buscaConvenentesConcedentesRecebidoErro,
    [Types.BUSCA_CONVENENTES_CONCEDENTES_RECEBIDO_SUCESSO]: buscaConvenentesConcedentesRecebidoSucesso,
})
